module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Footerintermezo"
    }
  }, [_c('section', {
    staticClass: "intermezo-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "to": 'portofolios'
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("\n                LIHAT SEMUA PORTOFOLIO\n              ")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "box-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                  Ayo buat aplikasimu sekarang juga\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n                  Dengan kami Brand anda semuanya menjadi lebih profesional\n                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe59521a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appFooterintermezo.vue
// module id = 85
// module chunks = 0